@import '~style-sheet-helpers/core.less';
@import (reference) '../../../products/product-details/style.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';
@import (reference) '../../../constants/spacing.module.less';

.plan-name {
  font-weight: 700;
}

.note {
  margin-bottom: 10px;
}

.list {
  list-style: inherit;
  padding: 10px 0 10px 16px;

  .item {
    display: list-item;
  }
}

.modal-base {
  width: 1160px;
  min-height: 200px;
  background-color: @settings-page--subscription-modal--background-color;
}

.modal-body {
  padding: 16px;
  background-color: @settings-page--subscription-modal--background-color;
}

.billing-modal-body {
  padding-top: 8px;
  background-color: @settings-page--subscription-modal--background-color;
  min-height: 300px;
  overflow: auto;
}

.cancellation-modal-body {
  padding: 12px;
  background-color: @settings-page--subscription-modal--background-color;
  line-height: 1.3;
}

.subscription-modal-footer-text {
  text-align: center;
  display: block;
}

.invoice-support-button {
  font-size: 16px;
}

.grid {
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 15px;
}

.invoices-header {
  display: grid;
  grid-template-columns:
    minmax(auto, 100px) minmax(auto, 100px) minmax(auto, 100px)
    minmax(auto, 100px) 1fr;
}

.archive-header {
  display: grid;
  grid-template-columns:
    minmax(auto, 130px) minmax(80px, 100px) minmax(90px, 100px)
    minmax(100px, 120px) minmax(100px, 120px) 1fr;
}

.header-cell {
  background-color: @settings-page--table--header--cell--background-color;
  height: 30px;
  line-height: @settings-page--table--line-height;
  font-size: @settings-page--table--font-size;
  border: @settings-page--table--border;
  border-left: none;
  padding-left: 10px;
  text-align: left;
  color: @settings-page--table--header--cell--text-color;
}

.grid-page {
  width: 100%;
  height: calc(100% ~'-' 45px);
  display: flex;
  position: relative;
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding: 8px;
  button {
    margin-left: 15px;
  }
}

.grid-header {
  background-color: @settings-page--subscription-grid-header--background-color;
  padding: 15px;
  font-size: 20px;
  font-weight: 400;
}

.grid-container {
  display: grid;
  grid-template-rows: repeat(auto-fill, 30px);
  font-size: 14px;
  direction: initial;
  width: auto;
  overflow: auto;
}

.invoices-grid-container {
  grid-template-columns:
    minmax(auto, 100px) minmax(auto, 100px) minmax(auto, 100px)
    minmax(auto, 100px) 1fr;
}

.archive-grid-container {
  grid-template-columns:
    minmax(auto, 130px) minmax(80px, 100px) minmax(80px, 100px)
    minmax(100px, 120px) minmax(100px, 120px) 1fr;
}

.item-cell {
  width: inherit;
  padding: 5px 10px;
  border-bottom: @settings-page--table--border;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 30px;
  display: flex;
  background-color: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
}

.number-cell {
  justify-content: flex-end;
}

.invoices-grid-description {
  padding: 10px 15px 5px;
}

.archive-grid-description {
  padding: 10px 15px;
}

.invoices-grid-support {
  padding: 5px 0 10px 15px;
}

.cancellation-modal-description {
  padding-bottom: 8px;
}

.cancellation-modal-feedback {
  padding-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
}

.cancellation-label {
  padding: 8px 0 4px;
  font-weight: 600;
  font-size: 14px;
}

.multiple-stamps-accounts-notice {
  margin: 4px 4px 0 24px;
  padding: 12px;
  background-color: @settings-page--subscription-notice--background-color;
  font-size: 12px;
  max-height: 250px;
  overflow-y: auto;
}

.choose-account-notice {
  padding-bottom: 8px;
}

.account-checkbox {
  padding-bottom: 4px;
}

.checkbox-height {
  height: auto;
}

.loading-indicator-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-indicator {
    height: 100px;
    width: 100px;
  }
}

.dropdown-wrapper {
  width: 500px;

  .other-option-info-banner {
    height: 25px;
  }
}

.paypal-button {
  margin: 10px 0 22px 20px;
}

.disabled {
  opacity: 0.5;
}

.radio-wrapper {
  margin-left: 20px;
  font-size: 12px;
}

.info-icon {
  height: 20px;
  width: 20px;
  margin: 22px 0 0 4px;
  color: @settings-page--subscription-info--text-color;
}

.paypal-button-wrapper {
  display: flex;
}

.payment-error {
  color: @settings-page--subscription-payment--error--text-color;
}

.billing-factory-wrapper {
  margin-top: 10px;
}

.subscription-billing-form {
  display: flex;
  flex-direction: column;
}

.billing-footer-buttons {
  border-top: 1px solid @settings-page--subscription-footer--border-color;
  min-height: 50px;
  line-height: 50px;
  padding: 0 16px;
  background: @settings-page--subscription-footer--background-color;
  text-align: right;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  position: sticky;
  bottom: 0;
  width: 100%;

  > button:first-child,
  > a:first-child {
    margin: 10px 0;
  }

  > button,
  > a {
    vertical-align: top;
    margin: 10px 0 10px 8px;
  }
}

.add-bundle-modal,
.fulfillment-provider-header-message {
  padding: 16px;
  line-height: 1.3;

  .bundle-feature-list {
    list-style-type: disc;
    margin-top: 16px;
    padding-left: 20px;

    li {
      display: list-item;
      padding-bottom: 6px;
    }
  }
}

.cancelation-support-modal {
  width: 500px;
}

.cancelation-support-modal-content {
  .add-bundle-modal();
}

.stamps-account-decision-page {
  margin-bottom: 24px;

  .banner-message {
    margin-left: 24px;
    width: max-content;
  }

  .cancel-accounts-radio {
    margin-top: 10px;
  }
}

.small {
  font-size: 12px;
}

.subscription-button {
  border-radius: 4px;
  border: 1px solid @settings-page--automation-rules-input-date-picker--border-color;

  &:hover {
    border-top-color: @settings-page--automation-rules-input-date-picker--border-color;
  }
}

.new-payments-table {
  overflow: hidden;

  .title-wrapper {
    align-items: center;
    justify-content: space-between;
    padding: @space-0 @space-16 @space-12;
  }

  .table-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin: @space-0;
  }

  .payment-method-container {
    .table-header {
      color: var(--grey-800);
      background-color: var(--grey-200);
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;

      th {
        padding: 8px 16px;
      }
    }

    .table-row {
      td {
        font-size: 14px;
        line-height: 24px;
        color: var(--grey-800);
        padding: @space-4 @space-16;
      }
    }
  }
}

.table-title {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 16px;
}

.divider {
  border-bottom: 1px solid var(--grey-300);
}

.payment-method-container {
  border-collapse: collapse;
  width: 100%;

  .table-header {
    text-align: left;
    border-bottom: 1px solid var(--grey-400) !important; //the !important is necessary here because of the tr:last-child on the main table rows
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    height: 40px;

    .left-head-cell {
      text-align: left;
      padding: 16px 8px 8px;
    }

    .right-head-cell {
      text-align: right;
      padding: 16px 8px 8px;
    }
  }

  .table-row {
    border-bottom: 1px solid var(--grey-300);
  }

  tr:last-child {
    border-bottom: none;
  }

  .left-store-cell {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    padding: 11px 0 11px 8px;
  }

  .right-store-cell {
    text-align: right;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    padding: 11px 8px 11px 0;
  }

  .menu-toggle {
    height: 32px;
    width: 32px;

    border-radius: 6px;

    color: @settings-page--inventory-warehouse-menu--text-color;

    &:hover,
    &:focus {
      background-color: @settings-page--inventory-warehouse-menu--hover--background-color;
      color: @settings-page--inventory-warehouse-menu--hover--text-color;
    }

    &:active {
      background-color: @settings-page--inventory-warehouse-menu--active--background-color;
      color: @settings-page--inventory-warehouse-menu--active--text-color;
    }
  }

  .open-menu-toggle {
    background-color: @settings-page--inventory-warehouse-open-menu--background-color;
    color: @settings-page--inventory-warehouse-open-menu--text-color;
  }
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}

.payment-error-banner {
  margin: 5px;
}

.radio-header {
  font-size: 12px;
  margin: 16px 0 0 20px;
}

.radios {
  display: flex;
}

.nickname-title {
  font-size: 12px;
  margin: 8px 0 4px;
}

.nickname {
  width: 100%;
}

.nickname-title-error {
  color: @inline-message--error--text-color;
}

.nickname-error {
  > div {
    > input {
      border: 1px solid @inline-message--error--text-color;
    }
  }
}

.select-address {
  display: flex;
  justify-content: flex-end;
  z-index: 2;
  right: 0;
  position: absolute;
}

.select-address-toggler {
  width: 100px;
  font-size: 12px;
}

.pays-for-tooltip {
  display: flex;

  > div {
    padding-left: 8px;
  }
}

.deactivate-bundle-paragraph {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.deactivate-bundle-buttons {
  display: flex;
}

.footnote-link {
  display: inline-flex;
  align-items: flex-end;

  > svg {
    height: 12px;
    margin-left: 4px;
  }
}

.loading-indicator {
  min-height: 100px;
}

.indicator {
  height: 100px;
  width: 100%;
  position: initial;
}

.ap-payments-table {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 125px;
  font-size: 14px;

  .title-wrapper {
    margin-bottom: auto;
  }

  .divider {
    width: 94%;
    border-bottom: 1px solid var(--grey-300);
    margin: 0 auto @space-8;
  }
}

.payment-row {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: @space-8 @space-16 @space-8 @space-16;

  .payment-row-label {
    font-weight: 500;
  }
}

.tooltip-wrapper {
  display: flex;
  flex-direction: row;
  gap: @space-4;
}
